import { useEffect, useState } from "react";
import { planApi } from "../api/client";

// useAccountPlans resolves the entitlement plan for each account login the
// viewer can see (their personal galaxy + member orgs), so per-account plan
// badges can render in the switcher / control room. Reads planApi (the
// account.plan projection) — the SAME source limits/quotas use — not the
// billing subscription, so the badge always matches entitlement and a dev plan
// override reflects immediately. Plan belongs to the GALAXY, not the person —
// keyed by account, fetched per account. Failures default to "free".
export function useAccountPlans(accounts: string[]): Record<string, string> {
  const [plans, setPlans] = useState<Record<string, string>>({});
  // Stable dep: re-fetch only when the actual set of accounts changes.
  const key = [...accounts].sort().join(",");

  useEffect(() => {
    if (accounts.length === 0) return;
    let cancelled = false;
    // One batched request for every visible galaxy (was N× planApi.get). The BE
    // returns plans only for galaxies the viewer is a member of; any login missing
    // from the response (omitted or on error) defaults to "free".
    planApi
      .getMany(accounts)
      .then((r) => {
        if (cancelled) return;
        const plans = Object.fromEntries(accounts.map((login) => [login, r.plans?.[login] ?? "free"]));
        setPlans(plans);
      })
      .catch(() => {
        if (!cancelled) setPlans(Object.fromEntries(accounts.map((login) => [login, "free"])));
      });
    return () => {
      cancelled = true;
    };
  }, [key]);

  return plans;
}
